import React from 'react';
import ServicePage from './ServicePage';
import { IconAlertTri, IconWind, IconUserCheck } from '../../components/Icons';

const DATA = {
  icon: <IconAlertTri size={32} />, category: 'mineria',
  title: 'Prevención Metano y Polvo de Carbón',
  subtitle: 'Planes especializados para la prevención de explosiones por metano y polvo de carbón en minería subterránea.',
  norm: 'Decreto 1886 de 2015 – Art. 179 a 220',
  desc: 'Diseñamos planes especializados para la detección, control y prevención de explosiones generadas por acumulación de grisú (CH₄) y polvo de carbón, incluyendo sistemas de monitoreo continuo y protocolos de respuesta a emergencias.',
  details: [
    'Monitoreo continuo de gases: CH₄, CO, CO₂, O₂',
    'Diseño de sistemas de detección y alarma temprana',
    'Protocolos de ventilación anti-grisú',
    'Plan de rociado y captación de polvo de carbón',
    'Capacitación al personal minero en seguridad',
    'Elaboración del PLASER (Plan de Seguridad)',
  ],
  related: [
    { icon: <IconWind size={18} />,      label: 'Planes de Ventilación', path: '/servicios/ventilacion' },
    { icon: <IconUserCheck size={18} />, label: 'Asesorías Mineras',     path: '/servicios/asesorias-mineras' },
  ],
};

export default function MetanoPolvo() { return <ServicePage data={DATA} />; }
